import { render } from "./StepForm.vue?vue&type=template&id=5421f6cf&scoped=true"
import script from "./StepForm.vue?vue&type=script&lang=js"
export * from "./StepForm.vue?vue&type=script&lang=js"

import "./StepForm.vue?vue&type=style&index=0&id=5421f6cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5421f6cf"]])

export default __exports__